import { encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import { message } from 'antd';
class TripSummaryStore {
    loading = false;
    total = 0;
    detailedJobData = [];
    tripData = [];

    rootStore;

    constructor(rootStore) {
        makeObservable(this, {
            loading: observable,
            total: observable,
            detailedJobData: observable,
            tripData: observable,

            loadData: action,
            loadTripData: action,
            exportExcel: action,
            exportpdf: action,
        });
        this.rootStore = rootStore;
    }

    async loadData({
        companyId,
        vehicleId,
        driverId,
        filterBy,
        fromDate,
        toDate,
        offset,
        limit,
        pageNo,
        hasInvoice,
        sortBy
    }) {
        this.loading = true;
        var postData = {
            companyId: companyId,
            vehicleId: vehicleId,
            driverId: driverId,
            filterBy: filterBy,
            fromDate: fromDate,
            toDate: toDate,
            offset: offset,
            limit: limit,
            pageNo: pageNo,
            hasInvoice: hasInvoice,
            sortBy: sortBy
        };

        var response = await postApi.getClient('report').post("/miscellaneous_report/tripSummaryReport", postData);


        this.tripSummaryData = response?.data?.data?.tripsummaryreport;

        this.total = parseInt(response?.data?.data?.TotalCount);

        this.loading = false;
    }

    async loadTripData({ vehicleId, fromDate, toDate, status }) {
        this.loading = true;
        var postData = {
            vehicleId: vehicleId,
            fromDate: fromDate,
            toDate: toDate,
            driverId: null,
            status: status,
        };

        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi
            .getClient()
            .post(
                "index.php?c=vehicle&a=getDailyTripSheet",
                "postData=" + base64Input
            );

        this.tripData = response?.data?.data;

        this.loading = false;
    }

    async exportExcel(getData) {
        try {
            await postApi.getClient("report").post("/miscellaneous_report/tripSummaryReport/download/excel", getData, {
                responseType: "blob",
            });
            this.pythonReportMessage = true;

        } catch (error) {
            this.pythonReportErrorMessage = true;
            message.error("Failed to download the report. Please try again.");
        }
    }

    async exportpdf(getData) {
        try {
            await postApi.getClient("report").post("/miscellaneous_report/tripSummaryReport/download/pdf", getData, {
                responseType: "blob",
            });
            this.pythonReportMessage = true;

        } catch (error) {
            this.pythonReportErrorMessage = true;
            message.error("Failed to download the report. Please try again.");
        }
    }
}

export default TripSummaryStore;
